import i18n from '@/lang/i18n'

export default function() {
    return [
        { type: 'customCheckbox' },
        {
            type: 'text',
            headerName: i18n.t('configuration.grid.externalCode'),
            colId: 'code',
            field: 'code',
            width: 150,
            minWidth: 80,
            suppressSizeToFit: true
        },
        {
            type: 'text',
            headerName: i18n.tc('configuration.sections.center', 1),
            colId: 'name',
            field: 'name',
            minWidth: 280,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            type: 'text',
            headerName: i18n.tc('configuration.sections.healthManagementArea', 1),
            colId: 'healthManagementArea.name',
            field: 'healthManagementArea.name',
            minWidth: 280,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            type: 'checkIconRenderer',
            headerName: i18n.t('configuration.grid.active'),
            colId: 'active',
            field: 'active',
            flex: 2,
            suppressSizeToFit: true
        }
    ]
}
